import { Checkbox, Divider, Switch } from 'antd';
import { memo, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { ICheckoutItem } from '../../../interfaces/ICheckout';
import { resolveAssetUrl } from '../../../utils/resolveAssetUrl';
import { useForm } from '../context';

const OrderBump = memo(() => {
  const { checkout, items, addItems, removeItems } = useForm();

  const [selectedBump, setSelectedBump] = useState<ICheckoutItem[]>([]);

  const bumpItems = checkout?.items?.filter((item) => item.type == 'order_bump') ?? [];

  if (!bumpItems.length) {
    return null;
  }

  function toggleItems(checked: boolean) {
    if (checked) {
      addItems(bumpItems);
      setSelectedBump(bumpItems);
      return;
    }

    removeItems(bumpItems);
    setSelectedBump([]);
  }

  function handleAddItem(item: ICheckoutItem) {
    addItems([item]);
    setSelectedBump((prev) => Array.from(new Set([...prev, item])));
  }

  function handleRemoveItem(item: ICheckoutItem) {
    removeItems([item]);

    setSelectedBump((prev) => {
      return prev.filter((i) => i.code !== item.code);
    });
  }

  const orderBumpTitle = checkout?.orderBumpTitle;
  const orderBumpSubtitle = checkout?.orderBumpSubtitle;
  const isAllItemsSelected = selectedBump.length === bumpItems.length;

  return (
    <>
      <Divider variant="dashed" />

      <div className="mt-4 rounded-lg bg-gray-100 p-6">
        <div className="flex flex-col gap-1">
          <p className="text-black font-medium leading-tight">{orderBumpTitle}</p>
          <p className="text-gray-600">{orderBumpSubtitle}</p>
        </div>

        <div className="mt-4 flex items-center gap-2">
          <Switch id="order-bump-switch" checked={isAllItemsSelected} onChange={toggleItems} />

          <label htmlFor="order-bump-switch" className="text-gray-600 cursor-pointer">
            Adicionar todas as ofertas
          </label>
        </div>

        <div className="grid grid-cols-1 gap-2 mt-4">
          {bumpItems.map((item) => {
            const isAdded = items.some((i) => i.code == item.code);
            const addedItem = items.find((i) => i.id == item.id);
            const totalDiscount = addedItem ? addedItem.amount - (addedItem.couponItem?.amount ?? addedItem.amount) : 0;

            return (
              <div
                onClick={() => {
                  if (!isAdded) {
                    handleAddItem(item);
                  }
                }}
                className={twMerge(
                  'w-full flex gap-4 items-center p-2 rounded-lg cursor-pointer transition-all duration-300 hover:bg-emerald-50',
                  isAdded && 'bg-emerald-50 cursor-default'
                )}
              >
                <Checkbox
                  checked={isAdded}
                  onChange={(event) => {
                    if (event.target.checked) {
                      handleAddItem(item);
                      return;
                    }

                    handleRemoveItem(item);
                  }}
                />

                <img
                  src={resolveAssetUrl(item.image)}
                  alt={item.description}
                  className="w-16 h-16 sm:w-20 sm:h-20 object-center object-cover rounded-lg"
                />

                <div className="flex flex-col justify-start flex-1">
                  <p className="text-black font-medium leading-tight">{item.description}</p>

                  <p className="text-gray-600 leading-tight hidden sm:block">{item.details?.slice(0, 100)}</p>

                  <div className="text-black font-medium mt-1">
                    {totalDiscount == 0 &&
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(item.amount / 100)}
                    {totalDiscount > 0 && (
                      <>
                        <s>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(item.amount / 100)}
                        </s>{' '}
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format((item.amount - totalDiscount) / 100)}
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

export default OrderBump;
